import { Mic, Calendar, MessageCircle, Zap } from "lucide-react";

export interface AIAgentFeature {
    id: string;
    icon: React.ElementType;
    title: string;
    description: string;
}

export const AI_AGENT_FEATURES: AIAgentFeature[] = [
    {
        id: "natural-command",
        icon: Mic,
        title: "Natural Command",
        description:
            "Just talk or text like you would to a human. Eisha understands voice notes and updates your calendar instantly."
    },
    {
        id: "scheduling",
        icon: Calendar,
        title: "Total Scheduling Autopilot",
        description:
            "Need to block time or move a slot? Just tell Eisha. She handles cancellations and rescheduling automatically."
    },
    {
        id: "alerts",
        icon: MessageCircle,
        title: "Auto-Patient Alerts",
        description: "Eisha handles patient communication and sends updates so you never make awkward calls."
    },
    {
        id: "admin",
        icon: Zap,
        title: "Zero-Touch Admin",
        description: "Eisha organizes and optimizes your schedule via simple voice notes or WhatsApp messages."
    }
];
